import {
  ActionCreatorWithPayload,
  createAction,
  createSlice,
} from "@reduxjs/toolkit";
import Bank from "../models/Bank";
import { UUID } from "../utils";
import listFactory from "./listFactory";

// TODO
// Move to appSlice.ts in the future
export interface UpdateActionPayload<T> {
  id: string;
  data: T;
  redirectOnSuccess?: boolean;
  resolve?: any;
  reject?: any;
}

export type UpdateAction<T> = ActionCreatorWithPayload<
  UpdateActionPayload<T>,
  string
>;

const { slicePart, selectors } = listFactory<Bank>("banks");

const initialState = {
  ...slicePart.initialState,
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setList: slicePart.reducers.setList,
    setItem: slicePart.reducers.setItem,
    setPaginatedList: slicePart.reducers.setPaginatedList,
    updateItem: slicePart.reducers.updateItem,
  },
});

export const { setList, setItem, setPaginatedList, updateItem } = slice.actions;

export const fetchBanks = createAction("fetchBanks");
export const fetchBank = createAction<{ id: UUID }, "fetchBank">("fetchBank");
export const setBankActiveFlag = createAction<{ id: UUID; value: boolean }>(
  "setBankActiveFlag"
);
export const setBankBetaFlag = createAction<{ id: UUID; value: boolean }>(
  "setBankBetaFlag"
);

export const updateBank = createAction<UpdateActionPayload<Bank>>("updateBank");

export const {
  selectList: selectBanks,
  selectItem: selectBank,
  selectPaginatedList: selectPaginatedBanks,
} = selectors;

export default slice.reducer;
